var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"loading":_vm.isLoading,"headers":_vm.headers,"items-per-page":500,"items":_vm.list.active_trip_details,"hide-default-footer":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }